import React, { useMemo } from "react";

import { copy } from "shared/assets";
import { FormBuilder } from "shared/components";
import { IAPIState, IFormButtons, IInfoBlock } from "shared/types";
import { getFields } from "./formData";

const { form } = copy;

interface InfoBlockFormProps {
  apiStatus?: IAPIState;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  blockExists?: boolean;
  handleSubmit: (data: IInfoBlock) => void;
  setFields?: (value: any) => void;
  showTitle?: boolean;
}

export const InfoBlockForm: React.FC<InfoBlockFormProps> = ({
  defaultValues,
  apiStatus,
  hasError,
  blockExists,
  handleSubmit,
  setFields,
  showTitle,
}) => {
  const buttons: IFormButtons = useMemo(
    () => ({
      primary: {
        children: blockExists ? form.save : form.create,
        "data-testid": "info_block_submit",
      },
    }),
    [blockExists]
  );

  return (
    <FormBuilder
      fields={getFields({ showTitle, setFields })}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      isSubmitting={apiStatus === IAPIState.pending}
      buttons={buttons}
      apiErrorMessage={hasError}
    />
  );
};
